// extracted by mini-css-extract-plugin
module.exports = {"message":"ContactMessage_message__3qoXJ"};